<template>
	<div class="vignet" />
	<v-stage
		ref="stage"
		:config="{ width, height, name: 'stage' }"
	>
		<v-layer
			ref="bg"
			:config="{ ...center }"
		>
			<v-wedge
				v-for="(wedge, i) in sunburstWedges"
				:key="i"
				:config="wedge"
			/>
		</v-layer>
		<v-layer v-if="items.length > 0">
			<v-group
				ref="pointer"
				:config="{
					name: 'pointer',
					x: center.x,
					y: center.y - radius - 30,
				}"
			>
				<v-image
					:config="{
						x: -20,
						y: -6,
						image: arrowImageObj,
						width: 40,
						height: 56,
					}"
				/>
			</v-group>
		</v-layer>
		<Wheel
			v-if="items.length > 0"
			:items="items"
			:radius="radius"
			:position="center"
		/>
	</v-stage>
	<div class="settings-button">
		<IconGear class="icon-gear" @click="isSettingsOpen = true" />
	</div>
	<ItemForm
		:is-open="isSettingsOpen"
		@update="onItemsUpdate"
		@close="isSettingsOpen = false"
	/>
</template>

<script>
/* eslint-disable */
import Konva from 'konva'
import { computed, ref, onMounted } from 'vue'

import Wheel from "./components/Wheel.vue";
import ItemForm from "./components/ItemForm.vue";
import IconGear from "./components/IconGear.vue";

export default {
    name: "App",
    components: {
        Wheel,
		ItemForm,
		IconGear,
    },
    setup() {
        
		const width = ref(window.innerWidth)
		const height = ref(window.innerHeight)
		
		const calcRadius = () => {
			const winSize = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth
			const radius = Math.round(0.7 * winSize / 2)
			return radius
		}

		const radius = ref(calcRadius())

		window.addEventListener('resize', () => {
			width.value = window.innerWidth
			height.value = window.innerHeight
			radius.value = calcRadius()
		})

		const center = computed(() => ({
			x: width.value / 2,
			y: height.value / 2,
		}))

		const sunburstWedges = computed(() => {
			const baseInfo = {
				radius: Math.sqrt(Math.pow(width.value / 2, 2) + Math.pow(height.value / 2, 2)),
				angle: 20,
			}
			return Array.from(Array(18)).map((_u, i) => {
				return {
					...baseInfo,
					rotation: i * 20,
					// fillRadialGradientStartPoint: {x: 0, y: 0},
					// fillRadialGradientStartRadius: 0,
					// fillRadialGradientEndPoint: {x: 0, y: 0},
					// fillRadialGradientEndRadius: baseInfo.radius,
					// fillRadialGradientColorStops: i % 2 === 0 ? [0, '#FFE69C', 1, '#FFE69C'] : [0, '#FFDE7D', 1, '#FFDE7D'],
					// fillPriority: 'radial-gradient',
					fill: i % 2 === 0 ? '#FFE69C' : '#FFDE7D',
				}
			})
		})

		const stage = ref()

		const bg = ref()
		let bgRotation = 0
		const bgAnimation = new Konva.Animation(() => {
			bgRotation += 0.1
			bg.value.getNode().rotation(bgRotation)
		});

		onMounted(() => bgAnimation.start())

		const arrowImageObj = new Image();
        arrowImageObj.src = '/arrow.svg';

		const items = ref([])

		const onItemsUpdate = updatedItems => {
			items.value = updatedItems
		}

		
		const isSettingsOpen = ref(false)

        return {
			stage,
            width,
            height,
			radius,
			center,
			items,
			bg,
			sunburstWedges,
			arrowImageObj,
			onItemsUpdate,
			isSettingsOpen,
        };
    },
};
</script>

<style>
html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
body {
  background: #f7f7f7;
  overflow: hidden;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.vignet {
	position: fixed;
	width: 100vw;
	height: 100vh;
	box-shadow: 0 0 200px rgba(208,166,40,0.7) inset;
	z-index: 10;
	pointer-events: none;
}
.settings-button {
	position: fixed;
	top: 20px;
	right: 20px;
	cursor: pointer;
	z-index: 11;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0.5;
}
</style>
